<template>
  <div class="container">
    <div class="background-layer"></div>
    <div class="contentContainer centerContent">

      <!-- Левая колонка: логин -->
      <div class="contentColumn">
        <div class="left-section">
          <img :src="currentMainMostaLabelLangIcon" class="back-login-image" />
        </div>
        <div class="center-section">
          <img :src="iconLoginCentralLine" width="16" height="16" class="central-login-line-image" />
        </div>

        <div class="right-section">
          <div class="loginComp">
            <div class="login-head">
              <div class="login-elem">
                <LangDropdown :languages="languages" :current-language="currentLanguage"
                  @language-change="selectLanguage" />
              </div>
              <img :src="currentMostaLabelLangIcon" width="16" height="16" class="mosta-label" />
            </div>
            <span v-if="loginPage">
              <label class="login-label">
                {{ $t('Login.EnterMessage') }}
              </label>
              <form class="autorizationElem" @submit.prevent="LoginInside">
                <div class="inputPanel">
                  <LoginInput v-model="login.Mail" :error="loginError" @clear-error="clearLoginError" />

                  <PasswordInput v-model="login.PassWord" :error="loginError" @clear-error="clearLoginError" />
                </div>

                <div class="button-and-recover-panel">
                  <div class="button-box">
                    <img :src="iconButtonLeftLine" width="16" height="16" class="button-line" />
                      <AppButton :label="$t('Login.Login')" :disabled="isLoginButtonDisabled" width="136px"
                      type="primary"/>
                    <img :src="iconButtonRightLine" width="16" height="16" class="button-line" />
                  </div>

                  <div class="loginClickableText" @click="showPasswordRecover">
                    {{ $t('Login.ForgotPassword') }}
                  </div>
                </div>

                <AppLoader v-if="isLoginLoading"/>

                <div v-if="loginErrorText" class="loginError">
                  {{ statusCode != 500 ? $t('Login.LoginError') : $t('Login.ServerError') }}
                </div>
              </form>

              <div class="pointer footer-elem">
                <LoginButtonLink :label="$t('Login.Unsigned')" :icon-src="iconUnsign"
                  :tooltip-text="$t('Login.UnsignedHintMessage')" :show-tooltip-on-hover="true"
                  @mouseenter="showHint = true" @mouseleave="showHint = false" />
                  <!-- <AppButton :label="$t('Login.Unsigned')" :icon-src="iconUnsign"
                  :tooltip-text="$t('Login.UnsignedHintMessage')" :show-tooltip-on-hover="true"
                  @mouseenter="showHint = true" @mouseleave="showHint = false" type="link"/> -->
              </div>
            </span>
            <!-- Восстановление пароля  -->
            <span v-if="passwordRecover">
              <label class="login-label-password">
                {{ $t('Login.PasswordRecovering') }}
              </label>
              <div class="autorization-elem-password">
                <label class="login-label-password-message">
                  {{ $t('Login.InputUsedEmail') }}
                </label>
                <LoginInput v-model="login.Mail" :error="loginError" @clear-error="clearLoginError" />


                <div class="button-and-recover-panel">
                  <div class="button-box">
                    <img :src="iconButtonLeftLine" width="16" height="16" class="button-line" />
                       <AppButton :label="$t('Login.PasswordRecoveringButton')" :disabled="isRecoverButtonDisabled"
                       @click="recoverPasswordInside" width="175px" type="primary"/>
                    <img :src="iconButtonRightLine" width="16" height="16" class="button-line" />
                  </div>

                  <div class="loginClickableText" @click="showAccessRecover">
                    {{ $t('Login.AuthorizationProblem') }}
                  </div>
                </div>

                <AppLoader v-if="isLoginLoading"/>

                <div v-if="loginErrorText" class="loginError">
                  {{ statusCode != 500 ? $t('Login.UserNotFoundError') : $t('Login.ServerError') }}
                </div>
              </div>

              <div class="footer-elem-password">
                <AppButton :label="$t('Login.Back')" @click="showLoginPage" type="link" width="111px"/>
              </div>
            </span>
            <!-- Восстановление пароля результат  -->
            <span v-if="passwordRecoverResult">
              <label class="login-label-password">
                {{ $t('Login.PasswordRecovering') }}
              </label>
              <div class="autorization-elem-password">
                <div class="recover-message-box">
                  <label class="login-label-recover-password-message">
                    {{ $t('Login.PasswordSentToMail') }}
                  </label>

                  <label class="login-label-recover-password-message">
                    {{ $t('Login.RepeatResponsePasswordMessage') }}
                  </label>
                </div>

                <div class="button-box" style="margin-top: 8px;">
                  <img :src="iconButtonLeftLine" width="16" height="16" class="button-line" />
                  <AppButton :label="$t('Login.SendAgain')" @click="recoverPasswordInside"
                    style="width: 153px !important;" :disabled="isLoginLoading" type="primary"/>
                  <img :src="iconButtonRightLine" width="16" height="16" class="button-line"  type="primary"/>
                </div>

                <AppLoader v-if="isLoginLoading"/>

                <div v-if="loginErrorText" class="loginError">
                  {{ statusCode != 500 ? $t('Login.UserNotFoundError') : $t('Login.ServerError') }}
                </div>
              </div>

              <div class="footer-elem-password">
                <AppButton :label="$t('Login.Back')" @click="showLoginPage" type="link"/>
              </div>
            </span>
            <!-- Восстановление доступа  -->
            <span v-if="accessRecover">
              <label class="login-label-access">
                {{ $t('Login.RestoringAccessToAccount') }}
              </label>
              <div class="autorization-elem-password">
                <div class="recover-message-box">
                  <label class="login-label-recover-password-message">
                    {{ $t('Login.SendContactDataMessage') }}
                  </label>
                </div>

                <AppTextarea v-model="AuthorizationProblemMessage"
                  :floating-label="$t('Login.DescribeProblem')" />

                <div class="button-box">
                  <img :src="iconButtonLeftLine" width="16" height="16" class="button-line" />
                     <AppButton :label="$t('Login.SendResponce')" :disabled="isSendResponseDisabled"
                     @click="recoverAccessInside" type="primary"/>
                  <img :src="iconButtonRightLine" width="14" height="16" class="button-line" />
                </div>

                <AppLoader v-if="isLoginLoading"/>

                <div v-if="loginErrorText" class="loginError">
                  {{ statusCode != 500 ? loginErrorText : $t('Login.ServerError') }}
                </div>

                <!-- <div v-if="recoverError" class="loginError">
                  {{ $t('Login.SendContactDataMessageError') }}
                </div> -->
              </div>

              <div class="footer-elem-password">
                <AppButton :label="$t('Login.Back')" @click="showLoginPage" type="link"/>
              </div>
            </span>
            <!-- Восстановление доступа результат  -->
            <span v-if="accessRecoverResult">
              <label class="login-label-access">
                {{ $t('Login.RestoringAccessToAccount') }}
              </label>
              <div class="autorization-elem-password">
                <label class="login-label-recover-password-message">
                  {{ $t('Login.LoginProblemNotificationDescription') }}
                </label>

                <div class="button-box">
                  <img :src="iconButtonLeftLine" width="16" height="16" class="button-line" />
                  <AppButton :label="$t('Login.SendAgain')" @click="recoverAccessInside" type="primary"/>
                  <img :src="iconButtonRightLine" width="16" height="16" class="button-line"
                    :disabled="isLoginLoading" />
                </div>

                <AppLoader v-if="isLoginLoading"/>

                <!-- <div v-if="recoverError" class="loginError">
                  {{ $t('Login.SendContactDataMessageError') }}
                </div> -->

                <div v-if="loginErrorText" class="loginLeftPanelElement loginError">
                  {{ statusCode != 500 ? loginErrorText : $t('Login.ServerError') }}
                </div>
              </div>

              <div class="footer-elem-password">
                <AppButton :label="$t('Login.Back')" @click="showLoginPage" type="link" />
              </div>
            </span>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, onMounted, computed } from 'vue';
import { i18n } from "@/i18n";
import { CommonResponse, LoginAsker, LoginMail, RecoverAsker } from "@/models/login/login";
import { authStore } from "@/store/login";
import { trim } from 'lodash';
import { useRoute } from 'vue-router';

import LoginInput from '@/components/login/LoginInput.vue';
import PasswordInput from '@/components/login/PasswordInput.vue';
import LangDropdown from '@/components/login/LangDropdown.vue';
import AppTextarea from '@/components/ui-kit/textarea/AppTextarea.vue';
// import AppPrimaryButton from '@/components/ui-kit/button/primary-button/AppPrimaryButton.vue';
import LoginButtonLink from '@/components/login/LoginButtonLink.vue';
import AppButton from '@/components/ui-kit/button/AppButton.vue';
import AppLoader from '@/components/ui-kit/loader/AppLoader.vue';

import '@/styles/inputs.scss';

export default {
  name: 'LoginPage',
  components: {
    LoginInput,
    PasswordInput,
    LangDropdown,
    AppTextarea,
    // AppPrimaryButton,
    AppButton,
    LoginButtonLink,
    AppLoader
  },

  setup() {

    //icons

    const iconLangRuPath = new URL('@/assets/image/icon-lang-ru.svg', import.meta.url).href;
    const iconLangEnPath = new URL('@/assets/image/icon-lang-en.svg', import.meta.url).href;
    const iconMostaLabelRu = new URL('@/assets/image/mosta-label-ru.svg', import.meta.url).href;
    const iconMostaLabelEn = new URL('@/assets/image/mosta-label-en.svg', import.meta.url).href;
    const iconMostaMainLabelRu = new URL('@/assets/image/main-back-mosta-logo-ru.svg', import.meta.url).href;
    const iconMostaMainLabelEn = new URL('@/assets/image/main-back-mosta-logo-en.svg', import.meta.url).href;
    const iconLoginCentralLine = new URL('@/assets/image/login-central-line.svg', import.meta.url).href;
    const iconUnsign = new URL('@/assets/image/no-sign-up.svg', import.meta.url).href;
    const iconButtonLeftLine = new URL('@/assets/image/login-left-line.svg', import.meta.url).href;
    const iconButtonRightLine = new URL('@/assets/image/login-right-line.svg', import.meta.url).href;
    const iconLoading = new URL('@/assets/image/icon-loading.svg', import.meta.url).href;

    const authstore = authStore();
    const route = useRoute();

    //password

    const isRecoverButtonDisabled = computed(() => {
      if (!login.value.Mail) {
        return true;
      }

      if (!showEmailValidateIcons.value) {
        return true;
      }

      if (isLoginLoading.value) {
        return true;
      }

      return false;
    });


    //login
    const showEmailValidateIcons = computed(() => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(login.value.Mail);
    })

    const isLoginButtonDisabled = computed(() => {
      if (!login.value.Mail || !login.value.PassWord) {
        return true;
      }

      if (!showEmailValidateIcons.value) {
        return true;
      }

      if (login.value.PassWord.length < 6) {
        return true;
      }

      if (isLoginLoading.value) {
        return true;
      }

      return false;
    });

    const clearLoginError = () => {
      authstore.clearErrorMessage();
    }

    //ProblemMessage

    const showProblemMessageIcons = computed(() => {
      return isProblemMessageFocused.value || AuthorizationProblemMessage.value.length > 0
    })

    const isProblemMessageFocused = ref(false);

    const onProblemMessageFocus = () => {
      isProblemMessageFocused.value = true
    }

    const onProblemMessageBlur = () => {
      isProblemMessageFocused.value = false
    }

    const clearProblemMessageField = () => {
      AuthorizationProblemMessage.value = '';
    }

    const isSendResponseDisabled = computed(() => {
      if (!trim(AuthorizationProblemMessage.value)) {
        return true;
      }

      if (isLoginLoading.value) {
        return true;
      }

      return false;
    });

    //hint

    let showHint = ref(false);

    //lang dropdown

    const languages = ref([
      {
        code: 'ru', icon: new URL('@/assets/image/icon-lang-ru.svg', import.meta.url).href,
        label: iconMostaLabelRu, mainLabel: iconMostaMainLabelRu
      },
      {
        code: 'en', icon: new URL('@/assets/image/icon-lang-en.svg', import.meta.url).href,
        label: iconMostaLabelEn, mainLabel: iconMostaMainLabelEn
      },
      {
        code: 'vn', icon: new URL('@/assets/image/icon-lang-vn.svg', import.meta.url).href,
        label: iconMostaLabelEn, mainLabel: iconMostaMainLabelEn
      },
    ]);

    let currentLanguage = ref('ru');

    const currentMostaLabelLangIcon = computed(() => {
      const lang = languages.value.find(lang => lang.code === currentLanguage.value);
      return lang ? lang.label : languages.value[0].label;
    });

    const currentMainMostaLabelLangIcon = computed(() => {
      const lang = languages.value.find(lang => lang.code === currentLanguage.value);
      return lang ? lang.mainLabel : languages.value[0].mainLabel;
    });

    const selectLanguage = (lang: string) => {
      currentLanguage.value = lang;
    }

    //lang

    const loc = "ru";

    // i18n.locale = "" + loc;
    // @ts-ignore
    i18n.global.locale = "" + loc;

    let recoverByMail = ref<RecoverAsker>({
      Language: 0,
      Value: ""
    });
    let recoverByName = ref<RecoverAsker>({
      Language: 0,
      Value: ""
    });

    const param = process.env.VUE_APP_API_URL + '/';

    let AuthorizationProblemMessage = ref("");

    let accessRecover = ref(false);
    let passwordRecover = ref(false);
    let loginPage = ref(true);
    let accessRecoverResult = ref(false);
    let passwordRecoverResult = ref(false);
    let serverAvailable = ref(true);
    let settsVisible = ref("hidden");
    let isLoginLoading = computed(() => authstore.loginIsLoading);
    let loginErrorText = computed(() => authstore.ErrorMessage);
    let statusCode = computed(() => authstore.statusCode);
    let loginError = computed(() => loginErrorText.value ? true : false);

    let login = ref<LoginMail>({
      Mail: '',
      PassWord: '',
      Id: 0
    });

    async function LoginInside() {
      let checker2 = new LoginAsker();
      checker2.Language = 2;
      checker2.Password = ReplaceBadThings(login.value.PassWord);
      checker2.Mail = ReplaceBadThings(login.value.Mail);
      checker2.ServerLink = param;

      const success = await authstore.LoginAuth(checker2);

      if(success) {
        const redirect = String(route.query.redirect ?? "");
        const target = redirect.startsWith("/") && !redirect.startsWith("//") && redirect !== "/login"
          ? redirect
          : "/main";

        window.location.assign(target);
      }
    }

    async function recoverPasswordInside() {
      let checker = new RecoverAsker();
      checker.Language = 1;
      checker.Value = ReplaceBadThings(login.value.Mail);

      const success = await authstore.recoverByEmail(checker);

      if(success)
      {
        accessRecover.value = false;
        passwordRecover.value = false;
        loginPage.value = false;
        accessRecoverResult.value = false;
        passwordRecoverResult.value = true;
      }
    }

    async function recoverAccessInside() {
      let checker = new RecoverAsker();
      checker.Language = 1;
      checker.Value = ReplaceBadThings(AuthorizationProblemMessage.value);


      const success = await authstore.recoverByName(checker);

      if(success)
      {
        accessRecover.value = false;
        passwordRecover.value = false;
        loginPage.value = false;
        accessRecoverResult.value = true;
        passwordRecoverResult.value = false;
      }
    }

    function ReplaceBadThings(str: string): string {
      return (str != null) ? str.replace(/\\/g, "\\\\").replace(/"/g, "\\\"").replace(/'/g, "`") : "";
    }

    const showPasswordRecover = () => {
      accessRecover.value = false;
      passwordRecover.value = true;
      loginPage.value = false;
      accessRecoverResult.value = false;
      passwordRecoverResult.value = false;
      recoverByMail.value.Value = login.value.Mail;

      authstore.clearErrorMessage();
    }

    const showLoginPage = () => {
      accessRecover.value = false;
      passwordRecover.value = false;
      loginPage.value = true;
      accessRecoverResult.value = false;
      passwordRecoverResult.value = false;
      recoverByMail.value.Value = login.value.Mail;

      authstore.clearErrorMessage();
    }

    const showAccessRecover = () => {
      accessRecover.value = true;
      passwordRecover.value = false;
      loginPage.value = false;
      accessRecoverResult.value = false;
      passwordRecoverResult.value = false;

      authstore.clearErrorMessage();
    }

    return {
      authStore,
      //password
      isRecoverButtonDisabled,
      //login
      showEmailValidateIcons,
      isLoginButtonDisabled,
      clearLoginError,
      //ProblemMessage
      AuthorizationProblemMessage,
      isProblemMessageFocused,
      showProblemMessageIcons,
      onProblemMessageFocus,
      onProblemMessageBlur,
      clearProblemMessageField,
      isSendResponseDisabled,
      //hint
      showHint,
      //lang dropdown
      languages,
      currentLanguage,
      iconLangEnPath,
      currentMostaLabelLangIcon,
      currentMainMostaLabelLangIcon,
      selectLanguage,
      //icons
      iconLangRuPath,
      iconMostaLabelRu,
      iconMostaLabelEn,
      iconUnsign,
      iconLoginCentralLine,
      iconMostaMainLabelRu,
      iconMostaMainLabelEn,
      iconButtonLeftLine,
      iconButtonRightLine,
      iconLoading,
      //authorization flags
      recoverByMail,
      recoverByName,
      accessRecover,
      passwordRecover,
      loginPage,
      accessRecoverResult,
      passwordRecoverResult,
      loginError,
      loginErrorText,
      serverAvailable,
      settsVisible,
      isLoginLoading,
      statusCode,
      login,
      // Login,
      LoginInside,
      recoverPasswordInside,
      recoverAccessInside,
      showLoginPage,
      showPasswordRecover,
      showAccessRecover,
    }
  }
}
</script>

<style>
.container {
  margin: 0;
  display: block;
  height: 100vh;
  width: 100vw;
  background: #F2F2F2;
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  overflow: hidden;
}

.contentColumn {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  grid-template-rows: 1fr;
  align-items: center;
  justify-items: center;
  width: 100%;
  padding-right: 16px;
}

.left-section {
  justify-self: end;
  padding-right: clamp(24px, 4.5vw, 80px);
}

.back-login-image {
  height: clamp(60px, 6vw, 84px);
  width: auto;
  object-fit: contain;
}

.center-section {
  justify-self: center;
}

.central-login-line-image {
  height: 500px;
  width: auto;
  object-fit: contain;
}

.right-section {
  justify-self: start;
  padding-left: clamp(24px, 4.5vw, 80px);
}

.loginComp {
  position: relative;
  width: 370px;
  height: 400px;
  background: url('@/assets/image/back-login-panel.svg');
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25);
  border-radius: 14px;
}

.background-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('@/assets/image/login-back-image.svg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: -1;
}

.loginForm {
  font-size: 15px;
  font-weight: bold;
  border: 2px solid #e9e9e9;
  border-radius: 5px;
  width: 180px;
  padding: 15px;
  margin: 0 auto;
  margin-top: 200px;
  color: lightslategray;
}

.login-head {
  display: flex;
  position: absolute;
  width: 338px;
  height: 24px;
  left: 16px;
  top: 24px;
}

.login-elem {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 8px;
  position: absolute;
  width: 51px;
  height: 24px;
  left: 0px;
  top: 0px;
  order: 0;
}

.login-label {
  position: absolute;
  width: 116px;
  height: 20px;
  left: calc(50% - 116px/2);
  top: 80px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #333333;
}

.recover-message-box {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.login-label-password-message {
  text-align: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 4px;
  width: 300px;
  height: 36px;
  left: calc(50% - 300px/2);
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #4F4F4F;
}

.login-label-recover-password-message {
  text-align: center;
  display: flex;
  flex-direction: row;
  padding: 0px;
  gap: 4px;
  left: calc(50% - 300px/2);
  width: 303px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #4F4F4F;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.login-label-password {
  position: absolute;
  width: 182px;
  height: 20px;
  left: calc(50% - 182px/2 + 4px);
  top: 80px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #333333;
}

.login-label-access {
  position: absolute;
  height: 20px;
  left: calc(50% - 182px/2 + 4px);
  top: 80px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #333333;
}

.lang-image {
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  width: 24px;
  height: 24px;
  filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.25));
  border-radius: 50px;
}

.lang-label {
  width: 19px;
  height: 18px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #4F4F4F;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.lang-elem {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 8px;
  position: absolute;
  width: 51px;
  height: 24px;
  left: 0px;
  top: 0px;
  order: 0;
}

.mosta-label {
  position: absolute;
  width: 120px;
  height: 32px;
  left: calc(50% - 120px/2);
  top: -4px;
  filter: drop-shadow(2px 3px 4px rgba(59, 59, 59, 0.24));

}

.loginButton {
  font-size: 15px;
}

.footer-elem {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  position: absolute;
  width: 174px;
  height: 18px;
  left: calc(50% - 174px/2);
  /* top: 366px; */
  bottom: 16px;
}

.footer-elem-password {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 4px;
  position: absolute;
  width: 111px;
  height: 18px;
  left: calc(50% - 111px/2);
  /* top: 366px; */
  bottom: 16px;
}

.footer-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}


.loadingContainer {
  display: flex;
  justify-content: center;
}

.loginLeftPanelElement {
  margin-top: 4px;
  margin-bottom: 4px;
}

.button-box {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.button-line {
  width: 72px;
  height: 3px;
  align-self: center;
  filter: blur(0.5px);
}

.autorizationElem {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 16px;

  position: absolute;
  width: 300px;
  height: 146px;
  left: calc(50% - 300px/2);
  top: 127px;
}

.autorization-elem-password {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 16px;
  position: absolute;
  width: 300px;
  height: 146px;
  left: calc(50% - 300px/2);
  top: 116px;
}

.rightLoginColumn {
  width: 60%;
  text-align: center;
}

.loginError {
  align-self: center;
  width: 236px;
  text-align: center;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: #FF5533;
  flex: none;
  order: 2;
  flex-grow: 0;

}

.loginClickableText:hover {
  cursor: pointer;
  text-decoration: underline;
}

.loginClickableText {
  color: #396742;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  align-self: center;
  width: max-content;
}

.centerContent {
  justify-content: center;
}

.contentContainer {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  height: 100%;
  width: 100%;
}

.mobile_offer_title {
  margin-top: 16px;
  margin-bottom: 16px;
  font-weight: bold;
  font-size: 20px;
}

.pointer {
  cursor: pointer;
}
</style>

<style>
.style-input:not(:focus):placeholder-shown {
  padding-top: 0;
}

#password-input-elm::-ms-reveal,
#password-input-elm::-ms-clear {
  display: none;
}

#password-input-elm::-webkit-credentials-auto-fill-button,
#password-input-elm::-webkit-caps-lock-indicator {
  display: none;
  visibility: hidden;
  pointer-events: none;
}

.search_buttons_container {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  display: flex;
  gap: 8px;
  align-items: center;
}

.style-input {
  transition: padding 0.3s ease;
}

.inputPanel {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
}

.button-and-recover-panel {
  display: flex;
  flex-direction: column;
  /* width: 100%; */
  gap: 8px;
}

.loading-image {
  align-self: center;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .loginComp {
    position: fixed;
    width: 100vw !important;
    height: 100vh !important;
    left: 0 !important;
    top: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    display: flex;
    flex-direction: column;
    background-size: cover;
  }

  .container {
    background: #F2F2F2;
  }

  .background-layer {
    display: none;
  }

  .contentContainer {
    justify-content: flex-start !important;
    align-items: center !important;
    padding: 0;
  }

  .contentColumn {
    width: 100% !important;
    padding: 0 !important;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .login-head {
    width: calc(100% - 32px) !important;
    left: 16px !important;
    top: 24px !important;
    position: absolute;
  }

  .loginComp>span {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    padding: 0 32px;
    box-sizing: border-box;
  }

  .login-label,
  .login-label-password,
  .login-label-access {
    position: relative !important;
    left: auto !important;
    top: auto !important;
    transform: none !important;
    text-align: center;
  }

  .autorizationElem,
  .autorization-elem-password {
    position: relative !important;
    left: auto !important;
    top: auto !important;
    width: 100% !important;
    /* max-width: 400px; */
    margin: 20px;
  }

  .inputPanel {
    display: flex;
    width: 100%;
    gap: 16px;
  }

  /* .style-input {
    width: 100% !important;
    box-sizing: border-box;
  } */

  .access-textarea {
    width: 100% !important;
  }

  .login-label-password-message,
  .login-label-recover-password-message {
    width: 100% !important;
    left: 0 !important;
    text-align: center;
    justify-content: center;
  }
}
</style>

<style>
:host {
  display: block;
  height: 100%;
}
</style>
